export default __webpack_public_path__ + "static/media/active_arrow_top.c515bddd.svg";